export const uploadToS3 = async (
  file: File,
  hubId: string,
): Promise<string> => {
  try {
    const s3ApiUrl = process.env.S3_API_URL;
    if (!s3ApiUrl) {
      throw new Error("S3 API URL not found in environment variables");
    }

    const response = await fetch(`${s3ApiUrl}/hub-logo/upload-url`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fileName: file.name,
        contentType: file.type,
        hubId,
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to get upload URL: ${response.statusText}`);
    }

    const { uploadURL, publicURL } = await response.json();

    const uploadResponse = await fetch(uploadURL, {
      method: "PUT",
      headers: {
        "Content-Type": file.type,
      },
      body: file,
    });

    if (!uploadResponse.ok) {
      throw new Error(`Failed to upload file: ${uploadResponse.statusText}`);
    }

    return publicURL;
  } catch (error) {
    console.error("Error uploading file to S3:", error);
    throw error;
  }
};
